import { render, staticRenderFns } from "./CompanyToiletAdd.vue?vue&type=template&id=37cf7237&"
import script from "./CompanyToiletAdd.vue?vue&type=script&lang=js&"
export * from "./CompanyToiletAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports